import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Injectable } from "@angular/core";
import { ITablesExhibitions } from "../../exhibitions/tables/tables-exhibitions.model";
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class TablesInvoicesService {
  header = new HttpHeaders({ "Content-Type": "application/json" });
  constructor(private http: HttpClient) {}

  getTables(appid: string) {
    const uriConnection = `${environment.exhibition_api.base_url}/${appid}/tables`;
    const params = new HttpParams().set("type", "invoices");
    return this.http.get<{ data: ITablesExhibitions[] }>(uriConnection, {
      headers: this.header,
      params,
    });
  }

  getTable(appid: string, id: string) {
    const uri = `${environment.exhibition_api.base_url}/${appid}/tables/${id}`;
    const params = new HttpParams().set("type", "invoices");
    return this.http.get(uri, {
      headers: this.header,
      params,
    });
  }

  putTable(table: ITablesExhibitions) {
    const uriConnection = `${environment.exhibition_api.base_url}/${table.app_id}/tables`;
    return this.http.put<ITablesExhibitions>(
      `${uriConnection}/${table.id}`,
      table
    );
  }
}
